// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3L9lT","head":"Table_head__3SsOy","col":"Table_col__lGX4O"};